import React from 'react'
import MuiPhoneInput from 'material-ui-phone-number'

const CustomPhone = (props) => {
    const shrink = props.shrink ? props.shrink.toString() : 'false'
    return (
        <div className="customInput">
            <MuiPhoneInput
                value={props.value}
                autoFocus={props.autoFocus}
                name={props.name}
                onChange={props.onChange || props.onChange}
                InputProps={{
                    inputProps: props.inputProps,
                    startadornment: props.startadornment,
                    shrink: shrink,
                }}
                id={props.id}
                label={props.label}
                type={props.type}
                size={props.size}
                disabled={props.disabled}
                variant="outlined"
                placeholder={props.placeholder}
                error={props.error}
                helperText={props.helperText}
            />
        </div>
    )
}

export default CustomPhone
